import { api } from "services"

export async function createPerfil(payload: any) {
  const { data } = await api.post("/permissions/roles", payload)

  return data
}
